module.exports = __webpack_public_path__ + "img/DCA6E90D81B3D0DB9CDCA502FD1F3F7E.3302c504.jpg";